import { HStack, VStack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { EquityEntity } from '@genial/services';
import { Box } from 'native-base';
import React from 'react';

import { rendaVariavelBuy, rendaVariavelSell } from '../../colors';
import { BuySellHeader } from '../BuySellHeader';
import { BuySellInfo } from '../BuySellInfo';

interface BuySellContainerProps extends EquityEntity {
  isLoading?: boolean;
}

export const BuySellContainer: React.FC<BuySellContainerProps> = (props) => {
  return (
    <VStack space={Spacing['stack.xxxs']}>
      <HStack h="8px">
        <Box flex={1} bg={rendaVariavelBuy} borderLeftRadius={BoxRadius.xs} />
        <Box flex={1} bg={rendaVariavelSell} borderRightRadius={BoxRadius.xs} />
      </HStack>
      <BuySellHeader />
      <BuySellInfo {...props} />
    </VStack>
  );
};
